<div class="app-container">
  <!-- Desktop/Tablet Header -->
  <app-header
    #header
    [menuItems]="menuItems"
    [profileItems]="profileItems"
    [staticMenuItems]="staticMenuItems"
    [isAuthenticated]="isAuthenticated"
    class="desktop-header"
  >
  </app-header>

  <!-- Mobile Header -->
  <div class="mobile-header" *ngIf="isAuthenticated">
    <h1 class="mobile-header-title">CareerPathway.com</h1>
  </div>

  <div class="app-body" *ngIf="isAuthenticated">
    <app-sidebar
      [menuItems]="menuItems"
      [staticMenuItems]="staticMenuItems"
      [isAuthenticated]="isAuthenticated"
      class="desktop-sidebar"
    ></app-sidebar>

    <div class="content-wrapper">
      <div class="breadcrumb-container" *ngIf="breadcrumbItems.length > 0">
        <p-breadcrumb
          [model]="breadcrumbItems"
          [home]="home"
          [style]="{ border: 'none', background: 'transparent' }"
        ></p-breadcrumb>
      </div>

      <main class="main-content">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>

  <div class="app-body" *ngIf="!isAuthenticated">
    <div class="content-wrapper full-width">
      <main class="main-content">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>

  <!-- Mobile Bottom Navigation -->
  <nav class="mobile-bottom-nav" *ngIf="isAuthenticated">
    <a
      class="nav-button"
      [class.active]="isActiveRoute('/feed') || router.url === '/'"
      [routerLink]="['/feed']"
      title="Discovery"
    >
      <i class="pi pi-compass"></i>
      <span>Discovery</span>
    </a>
    <a
      class="nav-button"
      [class.active]="isActiveRoute('/jobs')"
      [routerLink]="['/jobs']"
      title="Jobs"
    >
      <i class="pi pi-briefcase"></i>
      <span>Jobs</span>
    </a>
    <a
      class="nav-button"
      [class.active]="isActiveRoute('/chats')"
      [routerLink]="['/chats']"
      title="Chat"
    >
      <i class="pi pi-comments"></i>
      <span>Chat</span>
    </a>
    <a
      class="nav-button"
      [class.active]="isActiveRoute('/conference')"
      [routerLink]="['/conference']"
      title="Conference"
    >
      <i class="pi pi-calendar"></i>
      <span>Conference</span>
    </a>
    <a
      class="nav-button"
      [class.active]="isActiveRoute('/profile')"
      [routerLink]="['/profile']"
      title="Profile"
    >
      <i class="pi pi-user"></i>
      <span>Profile</span>
    </a>
  </nav>
</div>
